module.exports = __webpack_public_path__ + "img/6_130.8ed52b96.png";